import type { IconData } from '@stacksjs/iconify-core'

export const money: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M713 39q11-3 20 4t8 18v369q0 8-4 14t-12 9q-58 17-116 18t-116-5t-116-18t-116-18t-116-7t-116 16q-11 3-20-5t-9-18V48q0-18 16-23Q74 8 132 6t116 6t117 17l116 18q57 9 116 7t116-15M371 355q17 0 32-9t26-25t18-37t6-45t-6-45t-18-37t-26-25t-32-9t-32 9t-27 25t-17 37l-7 45q-4 24 7 45t17 37t27 25t32 9\"/>",
  "width": 750,
  "height": 710,
  "viewBox": "0 0 750 710"
}

export default money
